import { io } from 'socket.io-client'
import Cookies from 'js-cookie'

let socket = null

const getSocketBaseUrl = () => {
  const apiUrl =
    process.env.NODE_ENV === 'development'
      ? process.env.REACT_APP_DEV_BASE_URL
      : process.env.REACT_APP_PROD_BASE_URL
  return String(apiUrl || '').replace(/\/api\/v1\/?$/, '')
}

const getNotificationSocket = () => {
  const token = Cookies.get('accessToken')
  if (!token) return null
  if (!socket) {
    socket = io(getSocketBaseUrl(), {
      auth: { token },
      transports: ['websocket', 'polling'],
      // socket.io-client >= 4.8 stops at the first transport that fails unless
      // this is set, which makes the 'polling' entry above inert: a blocked
      // WebSocket upgrade would take notifications down with no fallback.
      tryAllTransports: true,
      reconnection: true,
    })

    // Each reconnect re-runs the server's handshake auth, so it has to carry
    // whatever token is current -- not the one captured when the socket was
    // built. Without this, every reconnect after a token refresh is rejected.
    socket.io.on('reconnect_attempt', () => {
      socket.auth = { token: Cookies.get('accessToken') }
    })

    // Handshake rejections ('Authentication required', 'Invalid tenant
    // session') surface here and nowhere else. Unlogged, a rejected socket is
    // indistinguishable from simply having no notifications to deliver.
    socket.on('connect_error', (error) => {
      console.error('Notification socket connect failed:', error?.message || error)
    })
  } else {
    socket.auth = { token }
  }
  return socket
}

export const subscribeToNotifications = ({ onNotification, onReconnect }) => {
  const activeSocket = getNotificationSocket()
  if (!activeSocket) return () => {}

  activeSocket.on('notification.created', onNotification)
  activeSocket.io.on('reconnect', onReconnect)
  if (!activeSocket.connected) activeSocket.connect()

  return () => {
    activeSocket.off('notification.created', onNotification)
    activeSocket.io.off('reconnect', onReconnect)
  }
}

export const subscribeToAttendanceRegularisationUpdates = ({ onUpdate }) => {
  const activeSocket = getNotificationSocket()
  if (!activeSocket) return () => {}

  activeSocket.on('attendance_regularisation.updated', onUpdate)
  if (!activeSocket.connected) activeSocket.connect()

  return () => {
    activeSocket.off('attendance_regularisation.updated', onUpdate)
  }
}

export const subscribeToSessionFreeze = ({ onFreeze }) => {
  const activeSocket = getNotificationSocket()
  if (!activeSocket) return () => {}

  activeSocket.on('tenant.session.freeze', onFreeze)
  if (!activeSocket.connected) activeSocket.connect()

  return () => {
    activeSocket.off('tenant.session.freeze', onFreeze)
  }
}

export const disconnectNotificationSocket = () => {
  socket?.disconnect()
  socket = null
}
